module.exports = __webpack_public_path__ + "img/capacitor-purple.13481ce0.webp";